import { AppCard } from '@/layout/AppComponents';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import * as currentPageAction from '../../../../../store/actions/currentPageAction';
import Translator from '../../../../components/helpers/Translator';
import _ from 'lodash';
import errorHandler from '../../../../components/error/ErrorHandler';

const BlockChangeOptions = () => {
  const dispatch = useDispatch();
  const {
    page,
  } = useParams();
  const pagination = useSelector((state) => state.currentPage?.pagination);
  const checkedPlantObligations = useSelector((state) => state.currentPage?.checkedPlantObligations);
  const plantObligationsPage = useSelector((state) => state.currentPage?.plantObligationsPage);

  // > SELECT ALL PAGE
  const handleSelectAllPage = async () => {
    try {
      const tempChecked = _.union(checkedPlantObligations, plantObligationsPage[page - 1]) || plantObligationsPage[page - 1];
      dispatch(currentPageAction.change('checkedPlantObligations', tempChecked, true));
    } catch (err) {
      dispatch(errorHandler(err, history));
    }
  };
  // < SELECT ALL PAGE

  // > SELECT ALL PLANT
  const handleSelectAllPlant = async () => {
    try {
      let tempAllObligations = [];
      plantObligationsPage.forEach((e) => tempAllObligations = [...e, ...tempAllObligations]);
      dispatch(currentPageAction.change('checkedPlantObligations', tempAllObligations, true));
    } catch (err) {
      dispatch(errorHandler(err, history));
    }
  };
  // < SELECT ALL PLANT

  // > INVERT SELECT PAGE
  const handleInvertSelectPage = async () => {
    try {
      const tempInverted = plantObligationsPage[page - 1].filter((e) => !checkedPlantObligations.includes(e));
      const removePage = _.differenceWith(checkedPlantObligations || [], plantObligationsPage[page - 1], _.isEqual);
      const inverted = _.union(removePage, tempInverted);
      dispatch(currentPageAction.change('checkedPlantObligations', inverted, true));
    } catch (err) {
      dispatch(errorHandler(err, history));
    }
  };
  // < INVERT SELECT PAGE

  // > INVERT SELECT PLANT
  const handleInvertSelectPlant = async () => {
    try {
      let tempAllObligations = [];
      plantObligationsPage.forEach((e) => tempAllObligations = [...e, ...tempAllObligations]);
      const inverted = tempAllObligations.filter((e) => checkedPlantObligations && !checkedPlantObligations.includes(e));
      dispatch(currentPageAction.change('checkedPlantObligations', inverted, true));
    } catch (err) {
      dispatch(errorHandler(err, history));
    }
  };
    // < INVERT SELECT PLANT

  // > DESELECT ALL
  const handleDeselectAll = async () => {
    try {
      dispatch(currentPageAction.change('checkedPlantObligations', [], true));
    } catch (err) {
      dispatch(errorHandler(err, history));
    }
  };
    // < DESELECT ALL

  if (!pagination) return <></>;

  return (
    <AppCard>
      <span className="btn btn-sm btn-outline-light mr-2" onClick={() => handleSelectAllPage()}>
        <Translator file="module-legalCompliance" name="select.all.current.page" />
      </span>
      <span className="btn btn-sm btn-outline-light mr-2" onClick={() => handleSelectAllPlant()}>
        <Translator file="module-legalCompliance" name="select.all.current.plant" />
      </span>
      <span className="btn btn-sm btn-outline-light mr-2" onClick={() => handleInvertSelectPage()}>
        <Translator file="module-legalCompliance" name="invert.current.page.selection" />
      </span>
      <span className="btn btn-sm btn-outline-light mr-2" onClick={() => handleInvertSelectPlant()}>
        <Translator file="module-legalCompliance" name="invert.current.plant.selection" />
      </span>
      <span className="btn btn-sm btn-outline-light mr-2" onClick={() => handleDeselectAll()}>
        <Translator file="module-legalCompliance" name="unselect.all" />
      </span>
      <br />
      <Translator
        file="module-legalCompliance"
        name="selected.obligations.of.all"
        variables={{
          selected: checkedPlantObligations
            ? checkedPlantObligations.length
            : 0,
          total: pagination.totalCount,
        }}
        isHtml
      />
    </AppCard>
  );
};

export default BlockChangeOptions;
